const trimEndSlash = value => value.replace(/\/$/, '');

export const API_URL = trimEndSlash(
    process.env.REACT_APP_TS_API_URL || 'https://study.itcenglish.com/api/ts'
);

export const CONTENTS_ROOT_URL = trimEndSlash(
    process.env.REACT_APP_TS_CONTENTS_URL || 'https://cdn.itcschool.co.kr/contents/ts'
);

export const SOUND_ROOT_URL = `${CONTENTS_ROOT_URL}/sound`;

export const COMMON_CONTENTS_ROOT_URL = trimEndSlash(
    process.env.REACT_APP_COMMON_CONTENTS_URL || 'https://cdn.itcschool.co.kr/contents/common'
);
